export default __webpack_public_path__ + "static/media/delievers6.67bb9f09.png";